import { Set } from '@everyboard/lib';
import { MoveGenerator } from '../../jscaip/AI/AI';
import { PylosMove } from './PylosMove';
import { PylosRules } from './PylosRules';
export class PylosMoveGenerator extends MoveGenerator {
    getListMoves(node, _config) {
        const state = node.gameState;
        const result = [];
        const stateInfo = PylosRules.getStateInfo(state);
        const climbings = PylosRules.getClimbingMoves(stateInfo);
        const drops = PylosRules.getDropMoves(stateInfo);
        const moves = climbings.concat(drops);
        for (const move of moves) {
            const postMoveState = state.applyLegalMove(move, false);
            let possibleCaptures = new Set();
            if (PylosRules.canCapture(postMoveState, move.landingCoord)) {
                possibleCaptures = PylosRules.getPossibleCaptures(postMoveState);
            }
            else {
                result.push(move);
            }
            for (const possiblesCapture of possibleCaptures) {
                const newMove = PylosMove.changeCapture(move, possiblesCapture.toList());
                result.push(newMove);
            }
        }
        return result;
    }
}
